import React from "react";
import { VerifyEmailSendAgain } from "../../components/CreateAccountVerifyEmail/VerifyEmailSendAgain";

const VerifyEmailSendAgainPage = (): React.ReactElement => (
  <VerifyEmailSendAgain />
);

export default VerifyEmailSendAgainPage;
